import Muuri from 'muuri'

export default class Blog {
  constructor(el) {
    this.el = el
    this.masonry = el.querySelector('.masonry')
    this.filterBtns = el.querySelectorAll('[data-filter]')
    this.activeFilter = '*'

    this.grid = new Muuri(this.masonry, {
      items: '.item-blog',
    })

    this.filterBtns.forEach(btn => {
      btn.addEventListener('click', () => this.setFilter(btn))
    })
  }

  setFilter(btn) {
    const filterValue = btn.dataset.filter
    if (filterValue === this.activeFilter) return

    this.activeFilter = filterValue
    this.filterBtns.forEach(b => b.classList.remove('is-active'))
    btn.classList.add('is-active')

    this.grid.filter(filterValue)
  }
}
